import React, { useContext, useState } from 'react';

import theme from '../../theme/theme';

import { SceneCanvasContext } from './SceneCanvasContext';
import { Character } from './types';

// taken from this icon: @mui/icons-material/Flip
const MUI_FLIP_ICON_SVG_PATH =
  'M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z';
interface FlipButtonProps {
  characterId: Character['id'];
}

export const FlipButton: React.FC<FlipButtonProps> = ({ characterId }) => {
  const { flipCharacter } = useContext(SceneCanvasContext);

  const [isTheMouseOverMe, setIsTheMouseOverMe] = useState(false);

  return (
    <svg
      x="50%"
      y="50%"
      width="15px"
      height="15px"
      style={{ overflow: 'visible', cursor: 'pointer' }}
      onMouseEnter={() => {
        setIsTheMouseOverMe(true);
      }}
      onMouseLeave={() => {
        setIsTheMouseOverMe(false);
      }}
      onClick={() => {
        flipCharacter(characterId);
      }}
    >
      <circle
        cx="0"
        cy="0"
        r="100%"
        fill={
          isTheMouseOverMe
            ? theme.palette.secondary.dark
            : theme.palette.secondary.main
        }
      />

      <path
        style={{ overflow: 'visible', fill: 'white' }}
        transform="translate(-9, -9) scale(0.8, 0.8)"
        d={MUI_FLIP_ICON_SVG_PATH}
      />
    </svg>
  );
};
